import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Container, Row } from 'react-bootstrap';

import AppLayout from '../../../layouts/AppLayout/AppLayout';
import { useLanguage } from '../../../context/LanguageProvider/LanguageProvider';
import PartnersLogos from '../../../components/PartnersLogos/PartnersLogos';
import { NioIcon } from '../../../components';

function HandshakeIllustration() {
  return (
    <svg
      className="jassp-partenaires-hero-icon"
      viewBox="0 0 120 88"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path d="M8 18h4M108 14h4M14 8v4M102 52v4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M96 20l3 3M18 24l-3 3M100 58l2-2M22 62l-2-2" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      <path
        d="M34 50c0-8 6-14 14-14h4c4 0 8 2 10 6 2-4 6-6 10-6h4c8 0 14 6 14 14v6H34v-6z"
        stroke="currentColor"
        strokeWidth="2.25"
        strokeLinejoin="round"
      />
      <path
        d="M42 56h36M38 62c4 4 10 6 22 6s18-2 22-6"
        stroke="currentColor"
        strokeWidth="2.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function ProjectPartnersBlock({ title, items }) {
  return (
    <article className="jassp-partenaires-project">
      <h3 className="h4 jassp-partenaires-project-title mb-3">{title}</h3>
      <ul className="jassp-about-list fs-16 text-gray-700 mb-0">
        {items.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
    </article>
  );
}

function Partenaires() {
  const { t } = useLanguage();

  const projects = [
    {
      title: t('partenaires.projects.moreMedDiet.title'),
      items: [
        t('partenaires.projects.moreMedDiet.item1'),
        t('partenaires.projects.moreMedDiet.item2'),
        t('partenaires.projects.moreMedDiet.item3'),
        t('partenaires.projects.moreMedDiet.item4'),
        t('partenaires.projects.moreMedDiet.item5'),
        t('partenaires.projects.moreMedDiet.item6'),
      ],
    },
    {
      title: t('partenaires.projects.medAgriCycle.title'),
      items: [
        t('partenaires.projects.medAgriCycle.item1'),
        t('partenaires.projects.medAgriCycle.item2'),
        t('partenaires.projects.medAgriCycle.item3'),
        t('partenaires.projects.medAgriCycle.item4'),
        t('partenaires.projects.medAgriCycle.item5'),
      ],
    },
    {
      title: t('partenaires.projects.techoney.title'),
      items: [
        t('partenaires.projects.techoney.item1'),
        t('partenaires.projects.techoney.item2'),
        t('partenaires.projects.techoney.item3'),
        t('partenaires.projects.techoney.item4'),
        t('partenaires.projects.techoney.item5'),
      ],
    },
  ];

  return (
    <AppLayout variant={2} titleKey="pages.partenaires.title" rootClass="layout-1">
      <div className="jassp-partenaires-page">
        <section className="jassp-partenaires-hero pt-7 pt-lg-120 pb-6 pb-lg-7">
          <Container>
            <Row className="justify-content-center text-center">
              <Col lg={10} xl={9}>
                <HandshakeIllustration />
                <h1 className="jassp-partenaires-hero-title display-4 fw-bold mb-4 mt-4">
                  {t('partenaires.hero.h1')}
                </h1>
                <p className="jassp-partenaires-hero-lead fs-18 mb-0 mx-auto">{t('partenaires.intro.summary')}</p>
              </Col>
            </Row>
          </Container>
        </section>

        <section className="jassp-hero-light-gap pb-7 pb-lg-120 bg-light">
          <Container>
            <Row className="justify-content-center">
              <Col lg={10} xl={9}>
                <section className="jassp-partenaires-intro">
                  <h2 className="jassp-about-section-title h3 mb-3">{t('partenaires.intro.h2')}</h2>
                  <p className="fs-18 text-gray-700 mb-0">{t('partenaires.intro.body')}</p>
                </section>

                <section className="jassp-partenaires-projects mt-5 pt-2">
                  <h2 className="jassp-about-section-title h3 mb-4 pb-2 border-bottom">
                    {t('partenaires.projects.h2')}
                  </h2>
                  {projects.map((project) => (
                    <ProjectPartnersBlock key={project.title} title={project.title} items={project.items} />
                  ))}
                </section>

                <section className="jassp-partenaires-funding mt-5 pt-5 border-top">
                  <PartnersLogos showHeading headingKey="partenaires.funding.h2" showLead={false} />
                </section>

                <div className="text-center mt-5 pt-4">
                  <Link to="/" className="btn btn-outline-primary">
                    <NioIcon name="arrow-left" className="me-2" />
                    {t('portfolio.backHome')}
                  </Link>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </div>
    </AppLayout>
  );
}

export default Partenaires;
